import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class BreakpointsService {
  _size: string;
  _device: string;
  private _sizeObs: BehaviorSubject<any>
  private _deviceObs: BehaviorSubject<any>
  public readonly sizeObs: Observable<any>;
  public readonly deviceObs: Observable<any>;

  constructor(private ngZone: NgZone) {
    window.onresize = (e) => {
        //ngZone.run will help to run change detection
        this.ngZone.run(() => {

          let size = this.calculateSize();
          if (size !== this.size) {
            this.size = size;
            this._sizeObs.next(this.size);
          }

          let device = this.deviceForSize(this.size);
          if (device !== this.device) {
            this.device = device;
            this._deviceObs.next(this.device);
          }
        });
    };

    this.size = this.calculateSize();
    this.device = this.deviceForSize(this.size);

    this._sizeObs = new BehaviorSubject(this.size);
    this.sizeObs = this._sizeObs.asObservable();

    this._deviceObs = new BehaviorSubject(this.device);
    this.deviceObs = this._deviceObs.asObservable();
  }

  calculateSize() {
    return window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
  }

  deviceForSize(size: string): string {
    let device = 'desktop';

    if (size === 'xs') {
      device = 'mobile';

    } else if (size === 'sm') {
      device = 'tablet';
    }

    return device;
  }

  get device() {
    return this._device;
  }
    
  set device(device: string) {
    this._device = device;
  }

  get size() {
    return this._size;
  }
    
  set size(size: string) {
    this._size = size;
  }
}


// WEBPACK FOOTER //
// ./src/app/breakpoints.service.ts